define([
    "dojo/_base/declare",
    "csi/action/Controller"
], function(declare,ActionController) {

    return declare(ActionController, {
        
        getConfirmButton: function() {
            return "DeleteInactivePrices";
        }
 
    });
});